import { Card, CardBody, CardHeader } from "../../components/card/card";
import { useEffect, useState } from "react";
import AddAsset from "../assets/add";
import CreateWorkOrder from "../work-order/add";
import InviteTeam from "../configurations/users/index";
import WorkOrder from "../work-order/orders";
import { useDashboardContext } from "../../contexts/NewDashboardContext";

function SetupCenter() {
  const { userSetupCenter } = useDashboardContext();
  const [selected, seSelected] = useState("registration");
  const [progress, setProgress] = useState(20);
  useEffect(() => {
    if (userSetupCenter) {
      const setup = userSetupCenter.split(",");
      setProgress(setup.length * 20 + 20);
    }
  }, [userSetupCenter]);
  const checkDone = (step) => {
    if (userSetupCenter) {
      return userSetupCenter.includes(step);
    }
    return false;
  };
  return (
    <div className={"row"}>
      <div className="col-sm-12">
        <h1>Getting Started</h1>
        <p>
          Complete the following steps to kickstart your new Maintenance
          program.
        </p>
      </div>
      <div className="col-sm-12 col-md-4">
        <Card>
          <CardHeader>
            <div>Complete Registration</div>
            <div className="progress">
              <div
                style={{ width: `${progress}%` }}
                className="progress-bar bg-success progress-bar-striped progress-bar-animated "
              >
                {progress}%
              </div>
            </div>
          </CardHeader>
          <CardBody>
            <div>
              <div className="alert alert-success  mb-2">
                <i className="bi bi-check-circle"></i> You have Completed
                Registration
              </div>
              {checkDone("asset") ? (
                <div className="alert alert-success  mb-2">
                  <i className="bi bi-check-circle"></i> You have Added an Asset
                </div>
              ) : (
                <div
                  className={`alert hover-dark ${
                    selected === "asset" ? "alert-warning" : "alert-light"
                  } mb-2`}
                  onClick={() => seSelected("asset")}
                >
                  <div className={"text-bold"}>
                    <i className="bi bi-boxes"></i> Add an Asset
                  </div>
                  <small>Manage your asset with the CMMS</small>
                </div>
              )}
              {checkDone("work order") ? (
                <div className="alert alert-success  mb-2">
                  <i className="bi bi-check-circle"></i> You have Created a Work
                  Order
                </div>
              ) : (
                <div
                  className={`alert hover-dark ${
                    selected === "work order" ? "alert-warning" : "alert-light"
                  } mb-2`}
                  onClick={() => seSelected("work order")}
                >
                  <div className={"text-bold"}>
                    <i className="bi bi-file-earmark-person"></i> Create a Work
                    Order
                  </div>
                  <small>
                    The First one just create a work order with your created
                    Asset
                  </small>
                </div>
              )}

              {checkDone("team") ? (
                <div className="alert alert-success  mb-2">
                  <i className="bi bi-check-circle"></i> You have invited your
                  Team
                </div>
              ) : (
                <div
                  className={`alert hover-dark ${
                    selected === "team" ? "alert-warning" : "alert-light"
                  } mb-2`}
                  onClick={() => seSelected("team")}
                >
                  <div className={"text-bold"}>
                    <i className="bi bi-people"></i> Invite your Team
                  </div>
                  <small>
                    You can invite your team to collaborate on the CMMS
                  </small>
                </div>
              )}
              {checkDone("assign") ? (
                <div className="alert alert-success  mb-2">
                  <i className="bi bi-check-circle"></i> You have invited your
                  Team
                </div>
              ) : (
                <div
                  className={`alert hover-dark ${
                    selected === "assign" ? "alert-warning" : "alert-light"
                  } mb-2`}
                  onClick={() => seSelected("assign")}
                >
                  <div className={"text-bold"}>
                    <i className="bi bi-people"></i> Assign Work Order
                  </div>
                  <small>Assign work order to your team members</small>
                </div>
              )}
            </div>
          </CardBody>
        </Card>
      </div>
      <div className="col-sm-12 col-md-8">
        {selected === "registration" && (
          <Card>
            <CardBody>
              <div>
                <h3>You have completed Registration Process.</h3>
                <p>
                  This step-by-step form guides you through task assignment,
                  scheduling, resource allocation, and status tracking. With a
                  structured workflow, you can manage maintenance requests
                  smoothly, reduce errors, and boost productivity
                </p>
              </div>
            </CardBody>
          </Card>
        )}
        {selected === "asset" && <AddAsset />}
        {selected === "work order" && <CreateWorkOrder />}
        {selected === "team" && <InviteTeam />}
        {selected === "assign" && <WorkOrder />}
      </div>
    </div>
  );
}

export default SetupCenter;
